import styled from 'styled-components';

import { Box } from '../../../styles/GlobalComponents';

export const EntryPackagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    margin: 0;
  }
`;

export const GridItem = styled(Box)<{
  selected: boolean;
  image: string;
}>`
  background: url(${({ image }) => image});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 30px;
  padding: 20px;
  text-align: center;
  > div {
  }
  margin-bottom: 0;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;
